import { Flex, HStack, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { ProductFeatures } from '@client/graphql/__generated__/types';
import { Home } from 'lucide-react';
import { FC } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { EmptyState } from '../../components/EmptyState';
import { Container } from '../../components/Layouts/Container';
import { OffMarketListings } from '../../components/Listings/OffMarketListings/OffMarketListings';
import { SIDEBAR_WIDTH_COLLAPSED } from '../../components/PageDetailLayout/SidebarItem';
import { NotSupportedMarket } from '../../components/ProductFeatures/NotSupportedMarket';

const WAITLIST_EMAIL = 'waitlist@useindigo.com';

const navLinkProps = {
  color: 'link.nav',
  fontWeight: 'medium',
  fontSize: 'xl',
  transition: 'color 0.3s',
  _activeLink: {
    color: 'link.navActive !important',
  },
  _hover: {
    textDecoration: 'none',
    color: 'link.navHover',
  },
};
export const ListingsPage: FC = () => {
  // Reset to useProdFeatureFlagEnabled('la-premium-storefronts'); once we fix feature flag adblock issue.
  const { isFeatureSupported } = useAppContext();
  const flagEnabled = true;

  if (!isFeatureSupported(ProductFeatures.LISTING_OFFER_DATA)) {
    return <NotSupportedMarket />;
  }

  return (
    <Container
      maxW={{ base: '100%', md: `calc(100vw - ${SIDEBAR_WIDTH_COLLAPSED})` }}
    >
      {flagEnabled ? (
        <VStack alignItems="stretch" justifyContent="stretch">
          <Flex
            alignItems="center"
            direction={{ base: 'column', md: 'row' }}
            gap={{ base: 4, sm: 0 }}
            mb={6}
            width="100%"
          >
            <Heading
              as="h2"
              display={{ base: 'none', md: 'block' }}
              flexGrow={1}
            >
              My Listings
            </Heading>
            {/* <PublicProfileFeatureButton /> */}
          </Flex>
          <OffMarketListings />

          <HStack
            justifyContent={{ base: 'center', md: 'flex-start' }}
            mt={6}
            spacing={6}
          >
            <Link as={NavLink} to="active" {...navLinkProps}>
              My Active Listings
            </Link>
            <Link as={NavLink} to="past" {...navLinkProps}>
              My Past Listings
            </Link>
          </HStack>

          <Outlet />
        </VStack>
      ) : (
        <EmptyState
          headerText="Premium Storefronts are invite-only for now"
          icon={Home}
          minH="70vh"
          subText={
            <Text>
              Want early access? Email us at{' '}
              <Link color="link.cyan" href={`mailto:${WAITLIST_EMAIL}`}>
                {WAITLIST_EMAIL}
              </Link>
            </Text>
          }
        />
      )}
    </Container>
  );
};
